import {
	GET_SEARCH_INTENTION,
	GET_AIRLINE_FLIGHTS,
	GET_SEARCH_INTENTION_FAILED,
	GET_SEARCH_INTENTION_RECEIVED,
	GET_SEARCH_WITH_REFERENCE,
	UPDATE_SEARCH_PROGRESS,
	AIRLINE_SEARCH_FLIGHTS_RECEIVED,
	AIRLINE_SEARCH_FLIGHTS_FETCHING,
	AIRLINE_SEARCH_FLIGHTS_DONE,
	AIRLINE_SEARCH_FLIGHTS_ERROR,
	GET_SEARCH_INTENTION_FROM_METASEARCH_RECEIVED
} from "../shared/constants";

const initialState = {
	progress: 0,
	partLoading: null,
	searchIntentionFailed: false,
	fetchingFlightsIntention: false,
	searchId: null,
	legacyId: null,
	fromCountry: null,
	toCountry: null,
	response: { status: 200 },
	tripType: null,
	cabin: null
};

export const searchStatus = (state = initialState, action) => {
	switch (action.type) {
		case GET_SEARCH_INTENTION:
			return {
				...state,
				fetchingFlightsIntention: true
			};

		case GET_SEARCH_INTENTION_RECEIVED:
			return {
				...state,
				searchIntentionFailed: false,
				fetchingFlightsIntention: false,
				searchId: action.searchId,
				legacyId: action.legacyId,
				createdDate: action.createdDate,
				fromCountry: action.fromCountry,
				toCountry: action.toCountry,
				response: { status: 200 },
				isInternational: action.isInternational,
				airlines: action.airlines.filter(airline => airline.status.enable),
				airlinesDisabled: action.airlines.filter(airline => !airline.status.enable),
				hasPromotion: action.hasPromotion,
				message: action.message
			};

		case GET_SEARCH_INTENTION_FROM_METASEARCH_RECEIVED:
			return {
				...state,
				searchIntentionFailed: false,
				fetchingFlightsIntention: false,
				searchId: action.searchId,
				legacyId: action.legacyId,
				createdDate: action.createdDate,
				fromCountry: action.fromCountry,
				toCountry: action.toCountry,
				response: { status: 200 },
				tripType: action.tripType,
				cabin: action.cabin,
				isInternational: action.isInternational
			};

		case UPDATE_SEARCH_PROGRESS:
			return {
				...state,
				partLoading: null,
				progress: action.progress
			};

		case GET_SEARCH_WITH_REFERENCE:
			return {
				...state,
				partLoading: action.airline
			};

		case GET_SEARCH_INTENTION_FAILED:
			return {
				...state,
				response: action.response,
				fetchingFlightsIntention: false,
				searchIntentionFailed: true
			};

		case GET_AIRLINE_FLIGHTS:
			return {
				...state,
				airlines: state.airlines.map(airline => {
					return {
						...airline,
						fetchStatus:
							airline.label == action.airline
								? AIRLINE_SEARCH_FLIGHTS_FETCHING
								: airline.fetchStatus
					};
				})
			};

		case AIRLINE_SEARCH_FLIGHTS_RECEIVED:
			return {
				...state,
				airlines: state.airlines.map(airline => {
					return {
						...airline,
						fetchStatus:
							airline.label == action.airline ? AIRLINE_SEARCH_FLIGHTS_DONE : airline.fetchStatus
					};
				})
			};

		case AIRLINE_SEARCH_FLIGHTS_ERROR:
			return {
				...state,
				airlines: state.airlines.map(airline => {
					return {
						...airline,
						fetchStatus:
							airline.label == action.airline ? AIRLINE_SEARCH_FLIGHTS_ERROR : airline.fetchStatus
					};
				})
			};

		default:
			return state;
	}
};
